import isEmpty from "lodash/isEmpty";

const sizeArray = [ 'XS', 'S', 'S/M', 'M', 'L', 'L/XL', 'XL', 'XXL', 'XXXL', 'B', 'C', 'D' ]

const helpers = {
    getImageBySize (image, size) {
        return image ? image.replace(image.charAt(image.lastIndexOf('.')), size) : ""
    }
}

export const getCustomerName = (firstName, middleName, lastName) => {
    return `${!isEmpty(firstName) ? firstName : ''} ${!isEmpty(middleName) ? middleName : ''}${!isEmpty(lastName) ? lastName : ''}`
}

export const getAtv = (totalAmount, totalTransactions) => {
    return (totalTransactions === 0 || totalAmount === 0) ? 0 : (totalAmount / totalTransactions)
}

export const toCapilatizeCase = (str) => {
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    })
}

export const getSortedSize = (sizes) => {
  const finalSizeArray = []
  if (typeof sizes === 'undefined') {
    return finalSizeArray
  }
  if (!isEmpty(sizes)) {
    const keySizes = Object.keys(sizes)
    if (keySizes[ 0 ] === 'Free Size') {
      for (const i in keySizes) {
        finalSizeArray.push(keySizes[ i ])
      }
    } else {
      const firstkey = parseInt(keySizes[ 0 ].charAt(0), 10)
      if (!isNaN(firstkey)) {
        for (const i in keySizes) {
          finalSizeArray.push(keySizes[ i ])
        }
      } else {
        for (const i in sizeArray) {
          if (keySizes.indexOf(sizeArray[ i ]) !== -1) {
            finalSizeArray.push(sizeArray[ i ])
          }
        }
      }
    }
  }
  return finalSizeArray
}

export const validateEmail = (inputText) => {
    let mobileNoRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
    if (inputText && inputText.match(mobileNoRegex)) {
        return true
    } else {
        return false
    }
}

export default helpers



// WEBPACK FOOTER //
// ./src/helpers/index.js